import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination, Autoplay } from "swiper/modules";

const images = ["/slide1.png", "/slide2.png", "/slide3.png"];

const ImageSlider = () => {
  return (
    <div className="image-slider mt-4">
      <Swiper
        modules={[Pagination, Autoplay]}
        pagination={{ clickable: true }}
        autoplay={{ delay: 3000, disableOnInteraction: false }}
        loop
        spaceBetween={20}
        slidesPerView={1}
        className="mySwiper"
      >
        {images.map((src, idx) => (
          <SwiperSlide key={idx}>
            <div className="img-slide">
              <img src={src} alt={`slide-${idx + 1}`} />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default ImageSlider;
